<template>
  <div class="page">
    <div class="bind-hero">
      <div class="section-kicker">
        {{ isReplace ? "REPLACE DEVICE" : "BIND DEVICE" }}
      </div>
      <h1>{{ isReplace ? "更换设备" : "机具绑定" }}</h1>
      <p v-if="isReplace">
        分别匹配原设备与更换设备，两个编号确认无误后直接完成更换。
      </p>
      <p v-else>选择服务套餐并填写机具资料，提交后直接进入微信支付。</p>
    </div>
    <div class="card replace-card" v-if="isReplace">
      <h3>设备编号匹配</h3>
      <p class="replace-tip">更换设备不需要重新选择套餐、支付或签署协议。</p>
      <div class="replace-grid">
        <label
          ><span>原设备编号 <em>*</em></span>
          <div class="code-row">
            <input
              v-model.trim="form.originalMachineCode"
              @input="originalMatched = null"
              placeholder="请输入当前已绑定的设备编号"
            /><button
              class="btn verify"
              type="button"
              @click="matchReplacement('original')"
            >
              匹配原设备
            </button>
          </div>
          <div class="match-result" v-if="originalMatched">
            <b>✓ 原设备匹配成功</b
            ><span
              >编号：{{ originalMatched.machine_code }}　设备：{{
                originalMatched.device_name
              }}</span
            >
          </div></label
        >
        <div class="replace-arrow">→</div>
        <label
          ><span>更换设备编号 <em>*</em></span>
          <div class="code-row">
            <input
              v-model.trim="form.machineCode"
              @input="newMatched = null"
              placeholder="请输入需要更换的新设备编号"
            /><button
              class="btn verify"
              type="button"
              @click="matchReplacement('new')"
            >
              匹配更换设备
            </button>
          </div>
          <div class="match-result" v-if="newMatched">
            <b>✓ 更换设备匹配成功</b
            ><span
              >编号：{{ newMatched.machine_code }}　设备：{{
                newMatched.device_name
              }}</span
            >
          </div></label
        >
      </div>
      <div class="actions">
        <button
          class="btn"
          :disabled="!originalMatched || !newMatched || submitting"
          @click="replaceDevice"
        >
          {{ submitting ? "正在更换…" : "提交更换" }}</button
        ><button class="btn ghost" @click="$router.back()">返回</button>
      </div>
    </div>
    <div class="card" v-else>
      <div
        v-if="signNotice.content"
        class="sign-notice rich-content"
        v-html="signNotice.content"
      ></div>
      <div class="form-grid">
        <label class="full"
          ><span>机具编号 <em>*</em></span>
          <div class="code-row">
            <input
              v-model.trim="form.machineCode"
              @input="matched = null"
              placeholder="请输入机身标签上的机具编号"
            /><button class="btn verify" type="button" @click="matchCode">
              匹配机具
            </button>
          </div></label
        ><label
          ><span>客户姓名 <em>*</em></span
          ><input
            v-model.trim="form.name"
            placeholder="请输入客户姓名" /></label
        ><label
          ><span>联系电话 <em>*</em></span
          ><input
            v-model.trim="form.phone"
            placeholder="请输入联系电话" /></label
        ><label class="full"
          ><span>安装地址 <em>*</em></span
          ><input
            v-model.trim="form.address"
            placeholder="请输入安装或使用地址"
        /></label>
      </div>
      <div
        class="match-result"
        v-if="matched"
        :class="{ warning: !matched.pcdnVerified }"
      >
        <b>✓ 本地机具匹配成功</b
        ><span
          >编号：{{ matched.machine_code }}　设备：{{
            matched.device_name
          }}</span
        ><span
          >PCDN：{{
            matched.pcdnMessage ||
            (matched.pcdnVerified ? "设备验证成功" : "尚未验证")
          }}</span
        >
      </div>
      <div class="package-picker">
        <h3>服务套餐 <em>*</em></h3>
        <button class="package-trigger" type="button" @click="packageOpen = !packageOpen">
          <span><small>当前选择</small><b>{{ selectedPackage ? selectedPackage.name : "请选择服务套餐" }}</b></span>
          <strong v-if="selectedPackage">￥{{ (selectedPackage.amount_fen / 100).toFixed(2) }}</strong>
          <i :class="{ open: packageOpen }">⌄</i>
        </button>
        <div class="packages" v-if="packageOpen && packages.length">
          <button type="button" v-for="x in packages" :key="x.id" class="package" :class="{ selected: form.packageId === x.id }" @click="selectPackage(x)">
            <span>{{ x.name }}</span><b>￥{{ (x.amount_fen / 100).toFixed(2) }}</b>
          </button>
        </div>
        <div v-if="packageOpen && !packages.length" class="package-empty">暂无可选套餐，请联系工作人员。</div>
      </div>
      <div class="actions">
        <button
          class="btn"
          :disabled="!matched || !form.packageId || submitting"
          @click="submit"
        >
          {{ submitting ? "正在唤起微信支付…" : "确认信息并微信支付" }}</button
        ><button class="btn ghost" @click="$router.back()">返回</button>
      </div>
    </div>
  </div>
</template>
<script>
import { api, ensureLogin, isWechat } from "../api";
export default {
  data: () => ({
    form: {
      packageId: null,
      originalMachineCode: "",
      machineCode: "",
      name: "",
      phone: "",
      address: "",
    },
    packages: [],
    matched: null,
    originalMatched: null,
    newMatched: null,
    signNotice: {},
    submitting: false,
    packageOpen: false,
  }),
  computed: {
    selectedPackage() {
      return this.packages.find((x) => x.id === this.form.packageId) || null;
    },
    isReplace() {
      return this.$route.query.mode === "replace";
    },
  },
  async created() {
    if (this.isReplace) return;
    try {
      const r = await Promise.all([
        api.get("/h5/content-config"),
        api.get("/h5/packages"),
      ]);
      const rows = r[0].data.data || [];
      this.signNotice = rows.find((x) => x.config_key === "sign_notice") || {};
      this.packages = r[1].data.data || [];
      if (this.packages.length === 1) this.form.packageId = this.packages[0].id;
      await this.resumePaid();
    } catch (e) {}
  },
  methods: {
    clearPendingFlow() {
      localStorage.removeItem("pendingApplicationId");
      localStorage.removeItem("pendingOrderNo");
      localStorage.removeItem("pendingDeviceSn");
    },
    selectPackage(row) {
      this.form.packageId = row.id;
      this.packageOpen = false;
    },
    async resumePaid() {
      const applicationId = localStorage.getItem("pendingApplicationId"),
        orderNo = localStorage.getItem("pendingOrderNo");
      if (!applicationId) return;
      try {
        const r =
          (
            await api.post(
              "/h5/pay/reconcile",
              {},
              { params: orderNo ? { orderNo } : {} }
            )
          ).data.data || {};
        if (
          r.flowActive &&
          String(r.applicationId || applicationId) === String(applicationId)
        ) {
          this.$router.replace(
            "/agreement?applicationId=" + (r.applicationId || applicationId)
          );
          return;
        }
        if (r.applicationStatus === "COMPLETED" || r.status === "CLOSED") {
          this.clearPendingFlow();
        }
      } catch (e) { /* Keep the pending order for the next confirmation attempt. */ }
    },
    async submit() {
      if (!this.form.packageId) return alert("请选择套餐");
      if (!this.matched) return alert("请先输入机具编号并完成匹配");
      if (this.isReplace && !this.form.originalMachineCode)
        return alert("请输入原机器机身编号");
      if (
        this.isReplace &&
        this.form.originalMachineCode === this.form.machineCode
      )
        return alert("原机器编号与新机具编号不能相同");
      if (!this.form.name || !this.form.phone || !this.form.address)
        return alert("请完整填写客户姓名、联系电话和安装地址");
      if (!isWechat()) return alert("请在微信内打开页面后支付");
      this.submitting = true;
      try {
        const uid = await ensureLogin();
        if (!uid) return;
        const x = (
          await api.post("/h5/bind", {
            packageId: this.form.packageId,
            originalMachineCode: this.form.originalMachineCode,
            machineCode: this.form.machineCode,
            customerName: this.form.name,
            phone: this.form.phone,
            address: this.form.address,
            replace: this.isReplace,
          })
        ).data.data;
        localStorage.setItem("pendingApplicationId", x.applicationId);
        localStorage.setItem("pendingDeviceSn", x.deviceSn);
        localStorage.setItem("machineCode", this.form.machineCode);
        await this.startPayment(x.applicationId);
      } catch (e) {
        alert(
          (e.response && e.response.data && e.response.data.message) ||
            e.message ||
            "提交或支付失败，请稍后重试"
        );
      } finally {
        this.submitting = false;
      }
    },
    async startPayment(applicationId) {
      const p = (
        await api.post("/h5/pay/create", {}, { params: { applicationId } })
      ).data.data;
      localStorage.setItem("pendingOrderNo", p.orderNo);
      return new Promise((resolve) => {
        const invoke = () =>
          window.WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            p,
            async (res) => {
              if (res.err_msg === "get_brand_wcpay_request:ok") {
                try {
                const confirmed = await this.confirmPaid(
                  p.orderNo,
                  applicationId
                );
                resolve(confirmed);
                } catch (e) {
                  alert(e.message || "Payment confirmation failed");
                  resolve(false);
                }
              } else {
                alert(
                  res.err_msg === "get_brand_wcpay_request:cancel"
                    ? "支付已取消，可确认资料后重新支付"
                    : "支付未完成：" + res.err_msg
                );
                resolve(false);
              }
            }
          );
        if (typeof window.WeixinJSBridge === "undefined")
          document.addEventListener("WeixinJSBridgeReady", invoke, {
            once: true,
          });
        else invoke();
      });
    },
    async confirmPaid(orderNo, applicationId) {
      let message = "微信正在处理支付结果，请稍候";
      for (let i = 0; i < 12; i++) {
        try {
          const r =
            (await api.post("/h5/pay/reconcile", {}, { params: { orderNo } }))
              .data.data || {};
          message = r.message || message;
          if (r.status === "PAID" || r.reconciled) {
            const id = r.applicationId || applicationId;
            alert("支付成功，请继续阅读并签署正式协议");
            this.$router.replace("/agreement?applicationId=" + id);
            return true;
          }
        } catch (e) {
          message =
            (e.response && e.response.data && e.response.data.message) ||
            message;
        }
        await new Promise((resolve) => setTimeout(resolve, 2000));
      }
      alert(message + "。支付成功后重新进入本页面，系统会继续处理。");
      return false;
    },
    async matchReplacement(role) {
      const code =
        role === "original"
          ? this.form.originalMachineCode
          : this.form.machineCode;
      if (!code)
        return alert(
          role === "original" ? "请输入原设备编号" : "请输入更换设备编号"
        );
      try {
        const row = (
          await api.get("/h5/device/replace/match", {
            params: { machineCode: code, role },
          })
        ).data.data;
        if (role === "original") this.originalMatched = row;
        else this.newMatched = row;
      } catch (e) {
        if (role === "original") this.originalMatched = null;
        else this.newMatched = null;
        alert(
          (e.response && e.response.data && e.response.data.message) ||
            "设备编号匹配失败"
        );
      }
    },
    async replaceDevice() {
      if (!this.originalMatched || !this.newMatched)
        return alert("请先完成两个设备编号的匹配");
      if (this.form.originalMachineCode === this.form.machineCode)
        return alert("原设备编号与更换设备编号不能相同");
      this.submitting = true;
      try {
        await api.post("/h5/device/replace", {
          originalMachineCode: this.form.originalMachineCode,
          newMachineCode: this.form.machineCode,
        });
        alert("设备更换成功");
        this.$router.replace("/");
      } catch (e) {
        alert(
          (e.response && e.response.data && e.response.data.message) ||
            "设备更换失败"
        );
      } finally {
        this.submitting = false;
      }
    },
    async matchCode() {
      if (!this.form.machineCode) return alert("请输入机具编号");
      try {
        this.matched = (
          await api.get("/h5/device-code/match", {
            params: { machineCode: this.form.machineCode },
          })
        ).data.data;
      } catch (e) {
        this.matched = null;
        alert(
          (e.response && e.response.data && e.response.data.message) ||
            "机具编号匹配失败"
        );
      }
    },
  },
};
</script>
<style scoped>
.bind-hero {
  background: linear-gradient(135deg, #123d30, #18b976);
  color: #fff;
  border-radius: 28px;
  padding: 34px;
  margin-bottom: 18px;
}
.bind-hero h1 {
  font-size: 34px;
  margin: 8px 0;
}
.bind-hero p {
  color: rgba(255, 255, 255, 0.82);
}
em {
  color: #e64a3b;
  font-style: normal;
}
.packages {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 8px 0 14px;
}
.package-picker {
  margin-top: 8px;
  padding-top: 10px;
  border-top: 1px solid #e4eee9;
}
.package-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  text-align: left;
  color: #173f31;
  background: #f7fbf9;
  border: 1px solid #d6e7df;
  border-radius: 14px;
  box-shadow: none;
}
.package-trigger span { flex: 1; }
.package-trigger small { display: block; color: #82928b; margin-bottom: 4px; }
.package-trigger b { display: block; font-size: 16px; }
.package-trigger strong { color: #08784a; font-size: 18px; }
.package-trigger i { font-style: normal; font-size: 22px; transition: transform .2s; }
.package-trigger i.open { transform: rotate(180deg); }
.package {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  gap: 10px;
  background: #f5faf7;
  color: #244e3d;
  border: 2px solid #dcebe4;
  box-shadow: none;
  padding: 11px 13px;
}
.package span {
  font-weight: 800;
}
.package b {
  font-size: 18px;
  color: #0c9259;
}
.package.selected {
  border-color: #11a768;
  background: #edfbf4;
}
.package-empty {
  padding: 16px;
  background: #fff5e4;
  color: #9b6a18;
  border-radius: 12px;
  margin: 14px 0;
}
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.form-grid label {
  display: grid;
  gap: 8px;
}
.form-grid span {
  font-weight: 800;
  color: #244e3d;
}
.full {
  grid-column: 1/-1;
}
.code-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
}
.verify {
  white-space: nowrap;
}
.match-result {
  margin-top: 16px;
  border: 1px solid #bce7d2;
  background: #effbf5;
  border-radius: 14px;
  padding: 13px 15px;
  color: #176243;
}
.match-result b,
.match-result span {
  display: block;
}
.match-result span {
  font-size: 13px;
  margin-top: 5px;
}
.warning {
  border-color: #efd59c;
  background: #fff9ea;
}
.actions {
  display: flex;
  gap: 12px;
  margin-top: 18px;
}
.ghost {
  background: #eef7f2;
  color: #0f8755;
  box-shadow: none;
}
.sign-notice {
  background: #f4faf7;
  border: 1px solid #dceee5;
  border-radius: 16px;
  padding: 15px;
  margin-bottom: 18px;
}
.replace-tip {
  background: #fff8e8;
  color: #8b641b;
  border-radius: 12px;
  padding: 12px 14px;
}
.replace-grid {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 18px;
  align-items: start;
  margin-top: 20px;
}
.replace-grid label {
  display: grid;
  gap: 9px;
}
.replace-grid label > span {
  font-weight: 800;
  color: #244e3d;
}
.replace-arrow {
  font-size: 32px;
  color: #18a76a;
  padding-top: 37px;
  font-weight: 900;
}
@media (max-width: 768px) {
  .bind-hero {
    padding: 22px;
  }
  .packages,
  .form-grid,
  .replace-grid {
    grid-template-columns: 1fr;
  }
  .replace-arrow {
    transform: rotate(90deg);
    text-align: center;
    padding: 0;
  }
  .actions {
    display: grid;
  }
  .code-row {
    grid-template-columns: 1fr;
  }
  .verify {
    width: 100%;
  }
}
</style>
